/* eslint-disable no-undef */
import { Fragment, useState, useEffect } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { toast } from 'react-toastify';
import { fetchWrapper } from '../../../../../../_helpers/fetchWrapper';
import { ErrorMessageHandler, fileUploader } from '../../../../../../_helpers/_methods';
import { FormGroup } from '../../../../../../Components/FormGroup/FormGroup';
import { FormattedMessage } from 'react-intl';
import { v4 as uuidv4 } from 'uuid';
import { VscLoading } from 'react-icons/vsc';
import { AiFillDelete } from 'react-icons/ai';
import styled from 'styled-components';

function ImagesPostEventActivities({
  postEventId,
  postEvent: { attached_documents = [] },
  setPostEvent,
  isCompleted,
  CAN_EDIT
}) {
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    mode: 'onBlur'
  });

  const [inputArray, setInputArray] = useState([uuidv4()]);
  const [fileObject, setFileObject] = useState({});
  const [attachedDocuments, setAttachedDocuments] = useState(attached_documents);

  const UploadedImagesArray = attachedDocuments.filter((doc) => doc.file_type === 'image');
  const showFileUploader = CAN_EDIT && !isCompleted && UploadedImagesArray.length <= 4;
  const AvialableImagesUploadSlot = 4 - UploadedImagesArray.length;
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  useEffect(() => {
    setAttachedDocuments(attached_documents);
  }, [attached_documents]);

  const handleAddInputFile = () => {
    setInputArray((prev) => [...prev, uuidv4()]);
  };

  const handelRemoveInputFile = (removedInputId) => {
    let tempInputArray = [...inputArray];
    tempInputArray = tempInputArray.filter((inputId) => inputId !== removedInputId);
    setInputArray(tempInputArray);

    let tempFileObject = { ...fileObject };
    delete tempFileObject[removedInputId];
    setFileObject(tempFileObject);
  };

  const handleFileLoad = (file, inputId) => {
    let tempFileObject = { ...fileObject };
    tempFileObject[inputId] = file;
    setFileObject(tempFileObject);
  };
  const onSubmit = async () => {
    try {
      if (postEventId) {
        setIsUploading(true);
        let FileArray = Object.values(fileObject);
        let fileIdArray = [];
        let fileCount = 0;
        let totalFileCount = FileArray.length;
        for (const file of FileArray) {
          fileCount++;
          const { ids } = await fileUploader(file, 'image');
          fileIdArray.push(ids[0]);
          setUploadProgress((fileCount / totalFileCount) * 100);
        }
        if (fileIdArray.length > 0) {
          const res = await fetchWrapper.post(`/event/post/${postEventId}/add_document/`, {
            documents: fileIdArray
          });
          setPostEvent((prevState) => {
            const tempState = { ...prevState };
            if (!tempState.attached_documents) {
              tempState.attached_documents = [];
            }
            tempState.attached_documents.push(...res.data);
            return tempState;
          });
          setFileObject({});
          setInputArray([uuidv4()]);
          toast.success(<FormattedMessage id="add_successfully" />);
          setIsUploading(false);
        }
      }
    } catch (e) {
      console.log(e);
      setIsUploading(false);
      toast.error('Something went wrong');
    }
  };
  const handleDeleteFile = async (id) => {
    try {
      const response = await fetchWrapper.post(`/event/post/delete-document/`, {
        documents: [id]
      });
      let tempAttachedDocuments = [...attachedDocuments];
      tempAttachedDocuments = tempAttachedDocuments.filter((doc) => doc.id !== id);
      setAttachedDocuments(tempAttachedDocuments);
      toast.success(<FormattedMessage id="successfully_deleted" />);
      console.log(response, 'response');
    } catch (e) {
      ErrorMessageHandler(e);
    }
  };
  return (
    <div>
      <h4 className="text-primary mb-4">
        <FormattedMessage id="postEventActivities.images" />
      </h4>
      <Fragment>
        {showFileUploader && (
          <Form className="edit_post_event_activity" onSubmit={handleSubmit(onSubmit)}>
            {!isCompleted && (
              <div className="form-row existingRow">
                {inputArray.map((inputId) => {
                  return (
                    <div key={inputId} className="d-flex mb-2 border rounded">
                      <FormGroup
                        type="file"
                        acceptedFormats={['image/jpeg', 'image/jpg', 'image/png']}
                        id={`document_file[${inputId}]`}
                        register={register}
                        error={errors}
                        disabled={isCompleted}
                        onChange={(e) => handleFileLoad(e.target.files, inputId)}
                      />
                      {!isUploading && inputArray.length > 1 && (
                        <Button
                          variant="outline-danger"
                          className="ms-2"
                          onClick={() => handelRemoveInputFile(inputId)}>
                          <FormattedMessage id="remove_files" />
                        </Button>
                      )}
                    </div>
                  );
                })}
                <div className="w-100 pt-1">
                  {!isUploading && AvialableImagesUploadSlot > inputArray.length && (
                    <div className="col-md-4 pt-1 text-left">
                      <Button
                        type="button"
                        variant="outline-primary"
                        onClick={handleAddInputFile}
                        className=" newFileBtn mb-2 btn-sm px-4">
                        + <FormattedMessage id="add_photos" />
                      </Button>
                    </div>
                  )}
                  {isUploading && (
                    <div className="text-center">
                      <progress
                        className="w-100"
                        key={uploadProgress}
                        value={uploadProgress}
                        max="100"
                      />
                    </div>
                  )}
                </div>
                <div className="d-flex w-100 justify-content-end">
                  <Button type="submit" disabled={isUploading} variant="success" className="px-4">
                    {isUploading ? (
                      <VscLoading className="spin" />
                    ) : (
                      <FormattedMessage id="button.submit" />
                    )}
                  </Button>
                </div>
              </div>
            )}
          </Form>
        )}
        {UploadedImagesArray?.length > 0 ? (
          <div className={!isCompleted ? 'mt-5 mb-3' : ' mb-3'}>
            <h3 className="sub-title">
              <FormattedMessage id="all_photos" />
            </h3>
            <div className="row">
              <div className="gallery cf">
                {UploadedImagesArray.map((doc) => (
                  <StyledFile key={doc.id}>
                    <img src={process.env.REACT_APP_BASE_URL + doc.file} />
                    {showFileUploader && (
                      <Button
                        className="delete-btn"
                        variant="outline-danger"
                        onClick={() => handleDeleteFile(doc.id)}>
                        <AiFillDelete />
                      </Button>
                    )}
                  </StyledFile>
                ))}
              </div>
            </div>
          </div>
        ) : (
          <div className="mt-3 alert alert-warning">
            <FormattedMessage id="no_photos_uploaded" />
          </div>
        )}
      </Fragment>
    </div>
  );
}

export default ImagesPostEventActivities;

const StyledFile = styled.div`
  position: relative;
  :hover {
    .delete-btn {
      opacity: 1;
      color: #dc3545;
    }
  }
  .delete-btn {
    position: absolute;
    background-color: whitesmoke;
    top: 0;
    right: 0;
    opacity: 0;
    transistion: opacity 0.3s ease-in-out;
  }
`;
